export const MOCK_CARDS = [
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-1.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-2.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-3.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-4.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-5.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-4.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview.jpg',
  'https://meetfrank-static-media.s3.amazonaws.com/images/faces/Sidebar+-+Profile+Preview-2.jpg',
];
